// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0e95274","239":"b084e71e","371":"0c8d0063","453":"733f28f0","455":"ae4b7c1b"}[chunkId] + ".chunk.js";
};